import {
  FEATURE_FLAGS_AGRONOMY_AGREEMENT,
  FEATURE_FLAGS_ENVIRONMENTAL_CROPS,
  FEATURE_FLAGS_SEED,
  IS_OFFLINE_ENABLED,
} from 'appConstants';
import { NotificationProvider } from 'shared/Notification';

import { combineComponents } from '../utils';
import { AccountRepresentativesProvider } from './AccountRepresentatives';
import { AddressesProvider } from './Addresses';
import { AgronomyAgreementCropsProvider } from './AgronomyAgreementCrops';
import { AgronomyAgreementServicesProvider } from './AgronomyAgreementServices';
import { AppProvider } from './App';
import { ConfirmDialogProvider } from './ConfirmDialog';
import { CropFailedOrdersProvider } from './CropFailedOrders';
import { CropOrdersProvider } from './CropOrders';
import { CustomersProvider } from './Customers';
import { EnvCropsFailedOrdersProvider } from './EnvCropsFailedOrders';
import { EnvCropsOrdersProvider } from './EnvCropsOrders';
import { EnvCropsProductsProvider } from './EnvCropsProducts';
import { FailedOrdersProvider } from './FailedOrders';
import { MetadataProvider } from './Metadata';
import { MultiAccountsProvider } from './MultiAccounts';
import { OfflineDataProvider } from './OfflineData';
import { OrdersProvider } from './Orders';
import { ProductsProvider } from './Products';
import { SeedFailedOrdersProvider } from './SeedFailedOrders';
import { SeedMetadataProvider } from './SeedMetadata';
import { SeedOrdersProvider } from './SeedOrders';
import { SeedProductsProvider } from './SeedProducts';

const providers = [
  AppProvider,
  NotificationProvider,
  AddressesProvider,
  CustomersProvider,
  MetadataProvider,
  OrdersProvider,
  ProductsProvider,
  AccountRepresentativesProvider,
  ...(IS_OFFLINE_ENABLED ? [OfflineDataProvider] : []),
  FailedOrdersProvider,
  ConfirmDialogProvider,
  MultiAccountsProvider,

  CropOrdersProvider,
  CropFailedOrdersProvider,
  ...(FEATURE_FLAGS_SEED
    ? [SeedMetadataProvider, SeedProductsProvider, SeedOrdersProvider, SeedFailedOrdersProvider]
    : []),

  ...(FEATURE_FLAGS_ENVIRONMENTAL_CROPS
    ? [EnvCropsProductsProvider, EnvCropsOrdersProvider, EnvCropsFailedOrdersProvider]
    : []),

  ...(FEATURE_FLAGS_AGRONOMY_AGREEMENT
    ? [AgronomyAgreementCropsProvider, AgronomyAgreementServicesProvider]
    : []),
];

export default combineComponents(providers);
